// fr_FR.js
import React from "react";
const fr_FR = {
    "ZHONGWEN":"Chinese",
    "YINGYU":"English",
    "XIBANYAYU":"Español",
    "DEYU":"Deutsch",
    "FAYU":"Français",
    "ALABOYU":"العربية",
    "EYU":"Русский",
    "MALAIYU":"Bahasa Malaysia",
    "YUENANYU":"Tiếng Việt",
    "TAIYU":"ภาษาไทย",
    "YINNIYU":"Bahasa Indonesia",
// components
    "XiaDanTiXing": "Remarque sur la commande",
    "NH_GDDBH_": "Bonjour, cette commande contient des produits avec un \"prix estimé\". Veuillez attendre la confirmation du prix par le client avant de payer. Voulez-vous vraiment passer la commande ?",
    "QueRenXiaDan": "Confirmer la commande",
    "WoZaiKanKan": "Je vais revoir",
    "XSQBDZ": "Afficher toutes les adresses",
// ChatRoom
    "ZBZCBQFH": "Les émojis ne sont pas pris en charge pour le moment",
    "FaSongLianJie": "Envoyer le lien",
    "YiChangXiaoXi": "Message anormal",
    "QingShuRu": "Veuillez entrer",
    "FaSong": "Envoyer",
// DateSelector
    "DQSJXYKSSJ": "L'heure actuelle est inférieure à l'heure de début",
    "DQSJCGJSSJ": "L'heure actuelle dépasse l'heure de fin",
    "QuXiao": "Annuler",
    "NianYueRi": "Année mois jour",
    "ShiFen": "Heure minute",
    "QueDing": "Confirmer",
    "Nian": "année",
    "Yue": "mois",
    "Ri": "jour",
    "Shi": "heure",
    "Fen": "minute",
// goods-list-card
    "Qi": "à partir de",
// goods-promotion
    "1GeCuXiao": "1 promotion",
    "ChaKanZengPin": "Voir les produits offerts",
    "JHDJSHS_1T": "Temps restant avant la fin de la promotion : {d} jours {h} heures {m} minutes {s} secondes",
    "YHGZ_ZPBKD": "Règle de promotion : Les produits offerts ne peuvent pas être cumulés",
    "YHGZ_AZZGM": "Règle de promotion : Bénéficiez des offres selon la quantité finale achetée",
    "GuanBi": "Fermer",
// group-filtrate
    "QuanBu": "Tout",
    "ZWXGSJ": "Aucune donnée pertinente",
    "ZuiDiJia": "Prix le plus bas",
    "ZuiGaoJia": "Prix le plus élevé",
    "LeiXing": "Type",
    "PinPai": "Marque",
    "BiaoQian": "Étiquette",
    "JiaGeQuJian": "Plage de prix",
    "SPMC_GG_BH_": "Nom du produit / Spécification / Référence / Première lettre",
    "ZuHeShaiXuan": "Filtrage combiné",
    "ChongZhi_CanShu": "Réinitialiser",
// image-upload
    "ZDKSC1ZTP": "Vous pouvez télécharger jusqu'à {num} images",
    "ZYXSCTP": "Seules les images sont autorisées",
    "SCTPDXBYXC": "La taille de l'image téléchargée ne doit pas dépasser {size}",
    "QBYCFSCTP_": "Veuillez ne pas télécharger des images en double ou assurez-vous que les noms d'images sont uniques",
    "ShangChuanChengGong": "Téléchargement réussi",
    "ZDKSC1Z": "Vous pouvez télécharger jusqu'à {num} fichiers",
// keyboard
    "CCSLZDXZ": "Dépassement de la limite maximale de quantité",
    "QiDingLiang": "Quantité minimale de commande",
    "ShouQi": "Replier",
    "ShanChu": "Supprimer",
// MultiPicker
    "FanHui": "Retour",
// order-cart
    "Dai": "En attente",
    "YiQuXiao": "Annulée",
    "ZengPin": "Produit offert",
    "1Zhong": "{num} types",
    "1Jian": "1 article",
    "HeJi": "Total",
    "DaiFu": "À payer",
// order-promotion
    "_DDM1YZ1J_": "【Commande d'un montant de {targetPrice} yuan, offert {presentNum} articles】",
    "_DDM1YLJ1Y_": "【Commande d'un montant de {targetPrice} yuan, réduction immédiate de {price} yuan】",
    "_DDM1YLX1Z_": "【Commande d'un montant de {targetPrice} yuan, bénéficiez immédiatement d'une remise de {discount}%】",
    "DingDanCuXiao": "Promotion sur la commande",
// page-ad
    "DLCKJG": "Connectez-vous pour voir le prix",
// page-floating
    "DianPuZhuYe": "Page d'accueil du magasin",
    "GouWuChe": "Panier",
    "ZaiXianKeFu": "Service client en ligne",
    "GeRenZhongXin": "Espace personnel",
    "LianXiDianHua": "Numéro de contact",
    "FanHuiDingBu": "Retour en haut",
// page-null
    "ZBDYML": "Page introuvable",
    "KNWZCW_HZY": "URL incorrecte ou page supprimée",
    "FanHuiShangJi": "Retour à la page parente",
    "FanHuiShouYe": "Retour à la page d'accueil",
// product-edit
    "SPQDBNWK": "La liste de produits ne peut pas être vide",
    "WoZhiDaoLe": "J'ai compris",
    "SFQRSCSP": "Voulez-vous vraiment supprimer le produit ?",
    "QueRen": "Confirmer",
    "ZYXSRSZBQB": "Seules les chiffres sont autorisés, avec au maximum 2 décimales",
    "ShangPinDanJia": "Prix unitaire du produit",
    "YSPYJ": "Prix original du produit",
    "QSRZDJG": "Veuillez entrer le prix spécifié",
    "ShuLiang": "Quantité",
    "DanWei": "Unité",
    "DanJia": "Prix unitaire",
    "BeiZhu": "Remarque",
    "YiChuShangPin": "Supprimer le produit",
    "XiuGai": "Modifier",
// yunshl
    "TPSLCCYXSZ": "Le nombre d'images dépasse la valeur autorisée !",
    "WJBDDY5M_QC": "Le fichier ne doit pas dépasser 5Mo, veuillez choisir à nouveau",
    "TPSCWC": "Téléchargement des images terminé",
// BusinessFilter
    "_DGSLM1JZ1J": "【Quantité commandée de {num} articles, offert {presentNum} articles】",
    "_M1JLXMJ1Y_": "【À partir de {num} articles, bénéficiez de {price} yuan par article】",
    "_DHJJZ1Y_": "【Prix de commande réduit à {price} yuan】",
    "_M1JLXMJ1Z_": "【À partir de {num} articles, bénéficiez d'une remise de {discount}% par article】",
    "_YDHJD1Z_": "【Prix de commande original avec une remise de {discount}%】",
    "YuJi": "Prévu",
    "MMYDDR": "DD/MM",
    "KaiShiFaHuo": "Commencer l'expédition",
    "_DGSLM1Z1_": "【Quantité commandée de {num} units, offert {presentNum} units】",
    "_M1LXM1Y_": "【À partir de {num} units, bénéficiez de {price} yuan par unit】",
    "_M1LXM1Z_": "【À partir de {num} units, bénéficiez d'une remise de {discount}% par unit】",
    "DaiQueRen": "En attente de confirmation",
    "DaiFaHuo": "En attente d'expédition",
    "DaiShouHuo": "En attente de réception",
    "YiWanCheng": "Terminée",
    "DaiFuKuan": "En attente de paiement",
    "YiFuKuan": "Payée",
    "YiZuoFei": "Annulée",
    "DaiShenHe": "En attente de vérification",
    "DaiHeXiao": "En attente de validation",
    "YiHeXiao": "Validée",
    "XianXiaZhiFu": "Paiement en ligne",
    "ZhiNengDaoZhangShiBie": "Virement offline (reconnaissance automatique de reception)",
    "WeiXinZhiFu": "Paiement WeChat",
    "KqZhiFu": "Paiement Kuaiqian (prise en charge de WeChat/Alipay)",
    "ZFBZF": "Paiement Alipay",
    "YuEZhiFu": "Paiement par solde",
    "HuoDaoFuKuan": "Paiement à la livraison",
    "DaiTuiHuo": "En attente de retour",
    "DaiTuiKuan": "En attente de remboursement",
    "ChuangJianDingDan": "Créer une commande",
    "BianJiDingDan": "Modifier la commande",
    "TiJiaoDingDan": "Soumettre la commande",
    "DingDanShenHe": "Vérification de la commande",
    "CaiWuShenHe": "Vérification financière",
    "BoHui": "Rejeter",
    "TianJiaShouKuan": "Ajouter un paiement reçu",
    "ZaiXianZhiFu": "Paiement en ligne (prise en charge de WeChat/Alipay/Pay JD/Yunshanfu)",
    "YinLianZhiFu": "Paiement UnionPay",
    "MercadoPagoZhiFu": "Paiement MercadoPago",
    "ShouKuanShenHe": "Vérification du paiement reçu",
    "ShouKuanZuoFei": "Annuler le paiement reçu",
    "ChuKu": "Sortie de stock",
    "ChuKuShenHe": "Vérification de sortie de stock",
    "FaHuo": "Expédier",
    "TianJiaWuLiu": "Ajouter la logistique",
    "XiuGaiWuLiu": "Modifier la logistique",
    "ChuKuZuoFei": "Annuler la sortie de stock",
    "ShouHuo": "Recevoir",
    "DingDanHeZhun": "Approuver la commande",
    "QuXiaoDingDan": "Annuler la commande",
    "CJTHD": "Créer un bon de retour",
    "DaYin": "Imprimer",
    "DaoChu": "Exporter",
    "DingDanWanCheng": "Commande terminée",
    "QiangZhiWanCheng": "Forcer la terminaison",
    "DingDanZuoFei": "Annuler la commande",
    "MaiZeng": "Acheter et obtenir un cadeau",
    "ZhiJiang": "Réduction directe",
    "DaZhe": "Remise",
    "YuShou": "Prévente",
    "DingDanManZeng": "Offre sur commande达到一定金额",
    "DingDanManJian": "Réduction sur commande达到一定金额",
    "DingDanManZhe": "Remise sur commande达到一定金额",
    "XinRenQuan": "Coupon nouveau client",
    "ManJianQuan": "Coupon de réduction达到一定金额",
    "ShangPinQuan": "Coupon produit",
    "DaiJieSuan": "En attente de règlement",
    "YiJieSuan": "Réglée",
    "QuanBuShangPin": "Tous les produits",
    "TuiJianShangPin": "Produits recommandés",
    "XinPin": "Nouveautés",
    "ReXiaoShangPin": "Produits populaires",
    "ChangYongShangPin": "Produits fréquemment utilisés",
// BusinessUtil
    "DaiShouKuan": "En attente de paiement",
    "BuFenShouKuan": "Paiement partiel",
    "YiShouKuan": "Paiement reçu",
    "BXYFP": "Aucune facture nécessaire",
    "ZZSPTFP": "Facture VAT ordinaire",
    "ZZSZYFP": "Facture VAT spéciale",
    "QiTaFaPiao": "Autres factures",
    "XianXia": "Offline",
    "WeiXin": "WeChat",
    "ZhiFuBao": "Alipay",
    "YuCunKuan": "Précompte",
    "XianXiaZhuangZhang": "Virement offline",
    "XianShangZhiFu": "Paiement en ligne",
    "YCKZF": "Paiement par précompte",
    "DaiTiJiao": "En attente de soumission",
    "KuaiDi": "Express",
    "SongHuoShangMen": "Livraison à domicile",
    "ShangMenZiQu": "Retrait en magasin",
    "WuLiuHuoYun": "Transport logistique",
    "QiTa": "Autre",
// check-util
    "QSRBXY6WDM": "Veuillez entrer un mot de passe d'au moins 6 caractères",
    "QSRBDY20WDM": "Veuillez entrer un mot de passe d'au maximum 20 caractères",
    "MMGSCW": "Format de mot de passe incorrect",
// common-utils
    "SJCW_QLXKF": "Erreur de données, veuillez contacter le service client",
    "ZBZCQD": "La fonction de pointage n'est pas prise en charge pour le moment",
    "HuJiao": "Appeler",
    "DLZHBCZ": "Compte de connexion inexistant",
    "QLXGLYKT": "Veuillez contacter l'administrateur pour l'activation",
    "GQYZHBJY": "Ce compte entreprise est désactivé",
    "QLXYSDH": "Veuillez contacter Yunshang Order",
    "GQYZHSYQJS": "La période d'essai du compte entreprise est terminée",
    "GQYZHYGQL": "Ce compte entreprise est expiré",
    "XYXFCNSY": "Un renouvellement est nécessaire pour continuer à utiliser",
    "GQYBCZCZH": "Cette entreprise ne dispose pas de ce compte",
    "NDDHZHYBQY": "Votre compte de commande a été désactivé par l'entreprise 1, impossible de se connecter. Veuillez contacter l'administrateur",
    "NYBSQY1DHZ": "Vous n'êtes plus un client partenaire de l'entreprise 1, impossible de se connecter. Veuillez contacter l'administrateur",
    "NDDPYBTY_B": "Votre magasin a été suspendu, impossible de se connecter. Veuillez contacter l'administrateur",
    "GZHWKTDSZB": "Cette fonction de version spéciale pour lumières n'est pas activée pour ce compte. Veuillez contacter l'administrateur",
    "WXSQYZYGQ": "La vérification d'autorisation WeChat a expiré",
    "WXSQSB": "Échec de l'autorisation WeChat",
    "WXSQSB_CWX": "Échec de l'autorisation WeChat, message d'erreur",
    "DengLuGuoQi": "Connexion expirée",
    "DLGQ_QCXDL": "Connexion expirée, veuillez vous reconnecter",
// data-constant
    "ShangJia": "Mise en ligne",
    "YiXiaJia": "Retiré du ligne",
    "YiJinYong": "Désactivé",
    "YiQiYong": "Activé",
    "YiTingYong": "Suspendu",
    "KeHuZhuCe": "Inscription client",
    "XinZengDaoRu": "Importation ajoutée",
    "DDDSH": "En attente de vérification de commande",
    "DCWSH": "En attente de vérification financière",
    "DaiChuKu": "En attente de sortie de stock",
    "DCK_BF_": "En attente de sortie de stock (partiel)",
    "DFH_BF_": "En attente d'expédition (partiel)",
    "DSH_BF_": "En attente de réception (partiel)",
    "DSK_BF_": "En attente de paiement (partiel)",
    "WTHSQ": "Aucune demande de retour",
    "THDSH": "Retour en attente de vérification",
    "THCLZ": "Retour en cours de traitement",
    "THYWC": "Retour terminé",
    "DYDHD": "Imprimer le bon de commande",
    "DYFHD": "Imprimer le bon d'expédition",
    "DCDHD": "Exporter le bon de commande",
    "DCFHDWE_P": "Exporter le bon d'expédition en fichier Excel/PDF",
    "TuiDanZuoFei": "Annuler le bon de retour",
    "DTHSH": "En attente de vérification de retour",
    "DaiRuKu": "En attente d'entrée en stock",
    "DRK_BF_": "En attente d'entrée en stock (partiel)",
    "DFK_BF_": "En attente de paiement (partiel)",
    "ChuangJianTuiDan": "Créer un bon de retour",
    "BianJiTuiDan": "Modifier le bon de retour",
    "TiJiaoTuiDan": "Soumettre le bon de retour",
    "TuiHuoShenHe": "Vérification de retour",
    "RuKu": "Entrée en stock",
    "RuKuShenHe": "Vérification d'entrée en stock",
    "RuKuZuoFei": "Annuler l'entrée en stock",
    "TianJiaFuKuan": "Ajouter un paiement",
    "FuKuanZuoFei": "Annuler le paiement",
    "FuKuanShenHe": "Vérification de paiement",
    "TuiDanWanCheng": "Bon de retour terminé",
    "QiTaChuKu": "Autre sortie de stock",
    "XiaoShouChuKu": "Sortie de stock pour vente",
    "PanKuiChuKu": "Sortie de stock pour perte d'inventaire",
    "DiaoBoChuKu": "Sortie de stock pour transfert",
    "CaiGouTuiHuo": "Retour d'achat",
    "TuiHuoRuKu": "Entrée en stock pour retour",
    "CaiGouRuKu": "Entrée en stock pour achat",
    "QiTaRuKu": "Autre entrée en stock",
    "PanYingRuKu": "Entrée en stock pour gain d'inventaire",
    "DiaoBoRuKu": "Entrée en stock pour transfert",
    "CJCGD": "Créer un bon d'achat",
    "BJCGD": "Modifier le bon d'achat",
    "TJCGD": "Soumettre le bon d'achat",
    "CGDZF": "Annuler le bon d'achat",
    "CGDWC": "Bon d'achat terminé",
    "CGTHZF": "Annuler le retour d'achat",
    "CGTHWC": "Retour d'achat terminé",
    "THDDY": "Imprimer le bon de retour",
    "THDDC": "Exporter le bon de retour",
    "CKDDY": "Imprimer le bon de sortie de stock",
    "CKDDC": "Exporter le bon de sortie de stock",
    "GLDZH": "Compte administrateur",
    "DHDZH": "Compte de commande",
    "ShenHeTongGuo": "Vérification acceptée",
    "SHBTG": "Vérification refusée",
    "WuXuFaPiao": "Aucune facture nécessaire",
    "DaiKeXiaDan": "Commander pour le client",
    "ZiZhuXiaDan": "Commander自主",
    "PCShangCheng": "Magasin PC",
    "APPShangCheng": "Magasin APP",
    "TVShangCheng": "Magasin TV",
    "WeiXinShangCheng": "Magasin WeChat",
    "ShouJiShangCheng": "Magasin mobile",
    "ADDXSMLTC": "Commission sur le bénéfice de vente de la commande",
    "ADDXSSRTC": "Commission sur le chiffre d'affaires de la commande",
    "AKHSSYG": "Par employé du client",
    "AnZhiDanRen": "Par créateur",
    "ATHJEBLKCT": "Deduction du montant de la commission proportionnellement au montant du retour",
    "DDYTHBJXTC": "Aucune commission si la commande contient un retour",
    "DaiDaKuan": "En attente de virement",
    "WeiKaiShi": "Pas encore commencé",
    "JinXingZhong": "En cours",
    "YiGuoQi": "Expiré",
// Utils.js
    "YouHuo": "En stock",
    "WuHuo": "En rupture de stock",
    "Yi": "100 millions",
    "QianWan": "Dix millions",
    "BaiWan": "Million",
    "Wan": "Dix mille",
    "Sheng1Tian": "1 jour restant",
    "Sheng1XiaoShi": "1 heure restante",
    "Miao": "seconde",
    "1Miao": "1 seconde",
    "GangGang": "Juste maintenant",
    "1FenZhongQian": "Il y a 1 minute",
    "1XiaoShiQian": "Il y a 1 heure",
    "1TianQian": "Il y a 1 jour",
    "1GeYueQian": "Il y a 1 mois",
    "1NianQian": "Il y a 1 an",
    "WeiZhiLeiXing": "Type inconnu",
// WechatUtil
    "YYGBCDSP_K": "Un bon produit, venez jeter un coup d'oeil",
    "ZanWeiSheZhi": "Pas encore configuré",
// app
    "HQWXSQXX": "Obtenir les informations d'autorisation WeChat",
// flexible
    "JGJYYDMBQ": "Le taux de zoom sera défini selon les balises meta existantes",
// index
    "NLJZZ": "Chargement en cours...",
// routes
    "ShangPinMingXi": "Détails du produit",
    "ShangPinLeiBie": "Catégorie de produit",
    "QXZFPNR": "Veuillez choisir le contenu de la facture",
    "QXZFPLX": "Veuillez choisir le type de facture",
    "QTXFPTT": "Veuillez saisir l'intitulé de la facture",
    "FaPiaoTaiTou": "Intitulé de la facture",
    "NSRSBH": "Numéro d'identification fiscale",
    "FaPiaoNeiRong": "Contenu de la facture",
    "FaPiaoXinXi": "Informations sur la facture",
    "KaiJuFaPiao": "Éditer la facture",
    "FaPiaoLeiXing": "Type de facture",
    "Han": "Inclut",
    "WeiHan": "N'inclut pas",
    "Shui": "Taxe",
    "QSRFPTT": "Veuillez entrer l'intitulé de la facture",
    "QSRNSRSBH": "Veuillez entrer le numéro d'identification fiscale",
// cart-bill
    "YiManZu_Man": "Condition satisfaite【à partir de",
    "ZaiGou": "Acheter plus",
    "YMZ_DHJJZ": "Condition satisfaite【Prix de commande réduit à",
    "JianJiangZhi": "article(s) réduit(s) à",
    "YMZ_YDHJD": "Condition satisfaite【Prix de commande original avec",
    "JianMeiJian": "article(s) par article",
    "SYTCSLW0_WFJRGWC": "Le nombre de packs restants est 0, impossible de l'ajouter au panier",
    "QingXuanXeShangPin": "Veuillez choisir un produit !",
    "GSPYXJ": "Ce produit a été retiré du ligne !",
    "ZJ2TN": "Au cours des 2 derniers jours",
    "QDQCXJSP": "Voulez-vous vraiment supprimer les produits retirés du ligne ?",
    "QingChuChengGong": "Suppression réussie",
    "TCSPBKJRGWC_QQXTCSPZYRGW": "Les produits en pack ne peuvent pas être ajoutés au panier. Veuillez annuler le pack avant de le déplacer dans le panier !",
    "SPSLBN": "La quantité de produit ne peut pas",
    "TaoCanHan": "Le pack contient",
    "TaoCan": "Pack",
    "QHDSL": "Veuillez vérifier la quantité",
    "SPSLBNDY": "La quantité de produit ne peut pas être inférieure à",
    "XianDingLiang": "Quantité limite",
    "YiRuShouCang": "Ajouter aux favoris",
    "QuanXuan": "Tout sélectionner",
    "JianZeng": "article(s) offert(s)",
    "JianLiXiang_Man": "article(s) bénéficiez immédiatement【à partir de",
    "Yuan_": "yuan】",
    "Zhe_": "% de remise】",
    "KCBZ_WFJRGWC": "Stock insuffisant, impossible d'ajouter au panier",
    "XDJEDYDY": "Montant de la commande supérieur ou égal à",
    "WYXJHYSXDSP": "Aucun produit retiré du ligne ou invalide !",
    "DYQDL": "Inférieure à la quantité minimale de commande",
    "ZSPG1J": "{count} type(s) de produit(s), total {number} article(s)",
    "WanCheng": "Terminer",
    "BianJi": "Modifier",
    "You": "Il y a",
    "ZSPBFHYQ_W": "type(s) de produit(s) ne satisfont pas les exigences, non sélectionnés, cliquez pour voir l'adresse par défaut",
    "SPSLBNGY": "La quantité de produit ne peut pas être supérieure à",
    "JXDJ_CKXYGBFHYQSP": "Continuez à cliquer pour voir le prochain produit qui ne satisfait pas les exigences",
    "XiaDan": "Passer commande",
    "JianJiang": "article(s) réduit(s)",
    "QRYCSP": "Voulez-vous vraiment supprimer le produit ?",
    "QXZXDSP": "Veuillez choisir les produits à commander",
    "KCBZ_QCXXZ": "Stock insuffisant, veuillez choisir à nouveau !",
    "KuCun": "Stock",
    "YCKXD": "yuan pour passer la commande",
    "QDSCSP": "Voulez-vous vraiment ajouter le produit aux favoris ?",
    "ShouCangChengGong": "Ajouté aux favoris avec succès",
    "GYXDL": "Supérieure à la quantité limite",
    "LiSheng": "Économisez immédiatement",
    "GWCHSKD_QGYGB": "Le panier est encore vide, allez faire un tour",
    "QuGuangGuang": "Aller faire un tour",
    "QCXJSP": "Supprimer les produits retirés du ligne",
    "ZongE": "Total",
    "YouHui": "Remise",
// cart-list
    "QXZJHRQ": "Veuillez choisir la date de livraison",
    "FuJiaFeiYong": "Frais supplémentaires",
    "ZhongShangPin_Gong": "type(s) de produit(s), total",
    "PeiSongShiJian": "Heure de livraison",
    "QXZPSSJ": "Veuillez choisir l'heure de livraison",
    "DingDanJinE": "Montant de la commande",
    "SCFJ_ZD4Z": "Télécharger des pièces jointes, maximum {num} fichiers, chaque fichier ne dépassant pas {size}",
    "KeYongShangPin": "Produits utilisables",
    "ShiYongShuoMing": "Instructions d'utilisation",
    "YouXiaoQi": "Validité",
    "Man": "à partir de",
    "BZZBZCTSFH": "Les remarques ne prennent pas en charge les caractères spéciaux pour le moment",
    "QingXuanZe": "Veuillez choisir",
    "KaiPiaoXuJia": "Frais supplémentaires pour la facture",
    "PeiSongFangShi": "Mode de livraison",
    "ShangPinZongJia": "Prix total des produits",
    "YouHuiQuan": "Coupon",
    "ZhangKeXan": "coupon(s) disponibles",
    "DDJEWMZ": "Montant de la commande non atteint",
    "WDYHQ": "Mes coupons",
    "KYYHQ": "Coupons utilisables",
    "YuanKeYong": "yuan utilisable",
    "ChaKanDingDan": "Voir la commande",
    "ShangPinHanShui": "Produit incluant la taxe",
    "SPWHS": "Produit non incluant la taxe",
    "GeDian": "point(s)",
    "QueRenDingDan": "Confirmer la commande",
    "XZSHDZ": "Ajouter une nouvelle adresse de livraison",
    "ShangPinQingDan": "Liste de produits",
    "WKYYHQ": "Aucun coupon utilisable",
    "HuChi": "Mutuellement exclusif",
    "DaiJinQuan": "Bon d'achat",
    "YunFei": "Frais de livraison",
    "ShuiFei": "Frais de taxe",
    "WKYYY": "Raison d'inutilisabilité",
    "YHQYGQ": "Coupon expiré",
    "WDYHQSYSJ": "Pas encore l'heure d'utiliser le coupon",
    "ZDSPJEWMZ": "Montant du produit spécifié non atteint",
    "BKYYHQ": "Coupons inutilisables",
    "RMBJE": "Montant en RMB",
// cart-presale-order
    "QXZPSFS": "Veuillez choisir le mode de livraison",
    "1ZSP_G": "1 type de produit, total",
    "YSSP_YJ": "Produit en prévente, prévu",
    "JiaoHuoRiQi": "Date de livraison",
    "GMJLY": "Laisser un message au vendeur",
// scan-to-cart
    "ZhengZaiChuLi...": "En traitement...",
    "FSCSP": "Produit non du magasin",
    "ZZCLTXM": "Traitement du code-barres...",
    "SPTJCG": "Produit ajouté avec succès",
    "QSTXM": "Veuillez scanner le code-barres",
    "SFSCDQSP": "Voulez-vous vraiment supprimer le produit actuel ?",
    "BQ_ZBDXGSP": "Désolé, aucun produit lié trouvé",
    "XuanZeDanWei": "Choisir l'unité",
    "JRGWC": "Ajouter au panier",
    "QXXZDJRSP": "Veuillez d'abord sélectionner les produits à ajouter",
    "ZhengZaiChuLi": "En traitement",
    "JRGWCCG": "Ajouté au panier avec succès",
    "ZanWuShangPin": "Aucun produit",
// earn-brokerage-share
    "XTYJBNFZSP": "Le système a copié le lien du produit pour vous !",
    "NKYHDDYDYJ": "Vous pouvez obtenir une commission correspondante. La commission peut être consultée dans \"Mon",
    "LiChaKan": "voir",
    "WeiXinHaoYou": "Amis WeChat",
    "ErWeiMa": "Code QR",
    "CASBEWM": "Appuyez longuement pour reconnaître le code QR",
    "FZSB_QCXFZ": "Copie échouée, veuillez recopier !",
    "TWEWM": "Code QR image-texte",
    "BCDXC": "Enregistrer dans l'album",
    "CATPBCDXC": "Appuyez longuement sur l'image pour l'enregistrer dans l'album",
    "FuZhiLianJie": "Copier le lien",
    "FXZYJ": "Partager pour gagner une commission",
    "YJZGKZQYJ": "Commission maximale prévue",
// goods-share
    "FXSPGLSKH": "Partager le produit avec les clients détaillants",
    "FXHJSCNZSD": "Après partage, votre mini-magasin mobile exclusif sera créé. Vous pouvez définir les prix des produits dans le magasin, saisir vos coordonnées et attirer les consommateurs à venir acheter.",
    "WSCDQJG_ND": "Prix actuel du mini-magasin : Votre prix de commande ×",
    "DaiSheZhi": "En attente de configuration",
    "PengYouQuan": "Moments",
    "GGFXSZ": "Modifier les paramètres de partage",
// wechat-login
    "QXSRZH": "Veuillez d'abord entrer le compte",
    "MMGSCW_6_20W": "Format de mot de passe incorrect (6-20 lettres ou chiffres)",
    "BDYYZH": "Lier un compte existant",
    "WXKJDL": "Connexion rapide WeChat",
    "BangDingZhangHao": "Lier le compte",
    "YYZH_QDL": "Déjà un compte, aller se connecter",
    "ZCXZH": "Créer un nouveau compte",
    "HuanYingNi": "Bienvenue",
    "ZH_SJHM": "Compte/Numéro de téléphone",
    "MiMa": "Mot de passe",
    "QDLHCZ": "Veuillez vous connecter avant de procéder",
// add-to-cart
    "KCBZ_BNTJG": "Stock insuffisant, impossible d'ajouter plus",
// combined-pay-online
    "ZhiFuChengGong": "Paiement réussi !",
    "ZFSB_QCXCS": "Paiement échoué, veuillez réessayer !",
//
    "QXXZGG": "Veuillez d'abord choisir la spécification",
    "SXGGX": "La spécification sélectionnée nécessite",
    "GMSLXYQDL_": "Quantité achetée inférieure à la quantité minimale de commande, veuillez réacheter !",
    "GMSLDYXDL_": "Quantité achetée supérieure à la quantité limite, veuillez réacheter !",
    "ShangPinBianHao": "Référence du produit",
    "QiDing": "Commande minimale",
    "SXGGDGSLBK": "La quantité commandée pour la spécification sélectionnée ne peut pas dépasser",
    "KCBZ_BNTJ": "Stock insuffisant, impossible d'ajouter",
    "QXXZSP": "Veuillez d'abord choisir le produit",
    "SLBNW0": "La quantité ne peut pas être 0",
    "QXZGG": "Veuillez choisir la spécification",
    "LiJiYuDing": "Réserver immédiatement",
// nav
    "ShouYe": "Accueil",
    "ShangPin": "Produits",
    "DingDan": "Commandes",
    "WoDe": "Moi",
// pay-online
    "ZhiFuQuXiao": "Annuler le paiement",
// account-log
    "ShangPinYongJin": "Commission sur produit",
    "YaoQingJiangLi": "Récompense d'invitation",
    "TiXian": "Retrait",
    "TiXianBoHui": "Retrait refusé",
    "ZhuanWeiYuE": "Convertir en solde",
    "Jin7Tian": "Derniers 7 jours",
    "Jin30Tian": "Derniers 30 jours",
    "ShouZhiMingXi": "Détails des revenus et dépenses",
    "ZanWuShuJu": "Aucune donnée",
// client-statistics
    "WoDeKeHu": "Mes clients",
    "WoDeYaoQing": "Mes invitations",
// distribution-home
    "LeiJiKeHu": "Clients cumulés",
    "LeiJiDingDan": "Commandes cumulées",
    "YaoQingHaoYou": "Inviter des amis",
    "LeiJiYaoQing": "Invitations cumulées",
    "LJSY_Y_": "Revenus cumulés (yuan)",
    "BHDJS": "Incluant les règlements en attente",
    "J7TSY_Y_": "Revenus des 7 derniers jours (yuan)",
    "J7TXZKH_R_": "Nouveaux clients des 7 derniers jours (personnes)",
    "KTXYJ": "Commission retrait possible",
    "XYJYO": "Il faut travailler plus dur",
    "ChangJianWenTi": "Questions fréquemment posées",
    "Q_ZMYJX_TG": "Q : Comment fonctionne \"Promouvoir pour gagner\" ?",
    "A_FXDPND_Z_": "A : Partagez les liens des pages avec l'icône \"gagner\" dans le magasin pour attirer les amis à cliquer. Lorsque les amis s'inscrivent (la relation client est définie comme inscription = liaison) ou passent une commande (la relation client est définie comme commande = liaison) et achètent des produits avec l'icône \"gagner\" dans le magasin, cela sera compté comme vos revenus de \"promouvoir pour gagner\" selon une méthode de calcul déterminée.",
    "Q_RHJS_TGZ": "Q : Comment sont calculés les revenus de \"Promouvoir pour gagner\" ?",
    "A_MGD_Z_TBD": "A : Chaque produit avec l'icône \"gagner\" a un certain pourcentage de commission. Sans ce marqueur, le produit ne participe pas à \"Promouvoir pour gagner\". Après que les amis ont payé avec succès via votre lien de partage, la commission sera calculée selon le pourcentage de commission de chaque produit dans la commande (la commission pour les promotions non participantes est 0), puis accumulée pour former les revenus de commission de cette commande. Dans le calcul des revenus, les frais de livraison, remboursements, réductions达到一定金额, etc., seront déduits, le prix de vente final prévaut.",
    "Q_TGZQ_DSY": "Q : Quand les revenus de \"Promouvoir pour gagner\" sont-ils crédités ?",
    "A_HYTGNDFX": "A : Après que les amis ont payé avec succès via votre lien de partage, vous pouvez voir cette promotion dans les commandes promotionnelles du centre de vente, le statut est \"En attente de règlement\". Après que le client a confirmé la réception et que la commande est terminée et réglée, ces revenus seront automatiquement transférés sur votre compte personnel et peuvent être retirés à tout moment.",
    "Q_LJKH_LJY": "Q : Pas d'avatars ou de noms dans la liste des clients cumulés et des invitations cumulées ?",
    "A_WXYQZYGZ": "A : WeChat exige que seul le suivi d'un compte de service certifié permette d'obtenir des avatars et des noms. Les clients des magasins avec un compte de service certifié suivent le compte officiel du magasin. Les comptes de service non certifiés suivent le compte officiel \"Yunshang Order\" puis cliquent sur n'importe quelle page de détail de produit du magasin pour obtenir des avatars et des noms.",
    "Q_WSMWASSG": "Q : Pourquoi je ne reçois pas de revenus de promotion bien que j'aie partagé selon les règles ci-dessus ?",
    "A_1_HYKNBW": "A : 1. Les amis n'ont peut-être pas établi de relation client avec vous (les amis ont cliqué sur les liens d'autres vendeurs pour s'inscrire ou passer des commandes) 2. Si les amis ouvrent votre lien de partage en dehors de l'environnement WeChat (comme le navigateur par défaut du téléphone) et que le navigateur n'a pas activé les cookies, la relation client ne peut pas être enregistrée, c'est-à-dire qu'aucune commande promotionnelle n'est enregistrée 3. Si aucune commande promotionnelle n'est enregistrée malgré les points ci-dessus, veuillez contacter le personnel",
//
    "XiaoShouZhongXin": "Centre de vente",
// generalize-goods
    "SPMC_GG_BH": "Nom du produit / Spécification / Référence",
    "YuJiZhuan": "Prévu à gagner",
// invitation-home
    "YaoQingKa": "Carte d'invitation",
    "YNYQJR_TGY": "Rejoignez-nous pour promouvoir et gagner des récompenses",
    "DJBCDXC": "Cliquez pour enregistrer dans l'album",
    "JYQKFSGHY_": "Envoyez la carte d'invitation à des amis, promouvez le magasin pour obtenir des récompenses",
// join-home
    "HuanYingJiaRu": "Bienvenue à rejoindre",
    "YQNCW": "Nous vous invitons à devenir",
    "LiJiJiaRu": "Rejoindre immédiatement",
// order-statistics
    "YuJiYongJin": "Commission prévue",
    "YongJin": "Commission",
    "YuJiJiangLi": "Récompense prévue",
    "JiangLi": "Récompense",
    "SPTGDD": "Commandes promotionnelles de produits",
    "YQJLDD": "Commandes de récompense d'invitation",
// performance-statistics
    "YeJiTongJi": "Statistiques de performance",
    "LJKH_R_": "Clients cumulés (personnes)",
    "SPYJ_Y_": "Commission sur produits (yuan)",
    "HanDaiJieSuan": "Incluant les règlements en attente",
    "XGMCJS": "Explication des termes liés",
    "KeHu": "Client",
    "HFXYBDLKHG": "Acheteurs ou distributeurs ayant établi une relation client avec le distributeur",
    "YaoQing": "Invitation",
    "FXYCGYQDXJ": "Distributeurs inférieurs invités avec succès par le distributeur",
    "FXYTJKHGMH": "Commission que le distributeur peut obtenir après avoir recommandé un client à acheter",
    "XJFXYTGSPH": "Récompense que le supérieur obtient après que le distributeur inférieur a promu un produit",
// posters-promoting
    "NiCheng": "Pseudonyme",
    "HaiBaoTuiGuang": "Promotion par affiche",
    "JHBFSGHY_T": "Envoyez l'affiche à des amis, promouvez le magasin pour obtenir des récompenses",
// settlement-home
    "JieSuanZhongXin": "Centre de règlement",
    "KTXJE": "Montant retrait possible",
    "TiXianJiLu": "Historique de retraits",
// withdraw-account
    "KHRXMBNWK": "Le nom du titulaire du compte ne peut pas être vide !",
    "KHHBNWK": "La banque d'ouverture ne peut pas être vide !",
    "YHKHBNWK": "Le numéro de carte bancaire ne peut pas être vide !",
    "SFZTPBNWK": "L'image de la carte d'identité ne peut pas être vide !",
    "YHKTPBNWK": "L'image de la carte bancaire ne peut pas être vide !",
    "BaoCunChengGong": "Enregistrement réussi !",
    "SCSFZ": "Télécharger la carte d'identité",
    "SCYHK": "Télécharger la carte bancaire",
    "BaoCun": "Enregistrer",
    "TiXianZhangHu": "Compte de retrait",
    "TS_QTXZSXX": "Remarque : Veuillez saisir des informations vraies, les retraits ne sont possibles qu'après approbation",
    "KHRXM": "Nom du titulaire du compte",
    "KaiHuHang": "Banque d'ouverture",
    "YinhangKaHao": "Numéro de carte bancaire",
    "QSRZSXM": "Veuillez entrer le nom réel",
    "QSRKHHMC": "Veuillez entrer le nom de la banque d'ouverture",
    "QSRYHKH": "Veuillez entrer le numéro de carte bancaire",
// withdraw-deposit
    "QXSZTXZH": "Veuillez d'abord configurer le compte de retrait",
    "QuSheZhi": "Aller configurer",
    "JEXY10Y_BKT": "Montant inférieur à 10 yuan, retrait impossible !",
    "JECGKTXJE": "Montant dépassant le montant retrait possible !",
    "CGDRKTXSX_": "Dépassement de la limite de retrait journalière, limite de retrait journalière de 20000 yuan !",
    "QueDingJiang": "Êtes-vous sûr de vouloir",
    "ZhuanDaoYuE": "convertir en solde ?",
    "1_JEDY10YSB": "1. Les montants inférieurs à 10 yuan ne peuvent pas être retirés ;",
    "2_BCTXDZSJ": "2. Le délai de règlement pour ce retrait est de 5 jours ouvrables à compter de la soumission réussie de la demande de retrait, limite de retrait journalière de 20000 yuan ;",
    "3_GBSRWHSS": "3. Ce revenu est soumis à l'impôt sur le revenu, veuillez vous déclarer et payer l'impôt sur le revenu auprès des autorités fiscales compétentes !",
    "4_ZDYEKYYS": "4. Le solde converti peut être utilisé pour les achats dans le magasin ;",
    "TXSQCG_QDD": "Demande de retrait réussie, veuillez attendre l'approbation",
    "JEDYKTXJE_": "Montant supérieur au montant retrait possible, impossible de convertir en solde !",
    "ZZYECG_QDG": "Conversion en solde réussie, veuillez vérifier dans l'espace personnel !",
    "BenCiTiXian": "Ce retrait",
    "ZhuangDaoYuE": "Convertir en solde",
    "TiXianDao": "Retirer sur",
    "JEW0BKZZYE": "Montant de 0 impossible à convertir en solde !",
    "DRTXSX2WY": "Limite de retrait journalière de 20000 yuan",
    "QuanBuTiXian": "Tout retirer",
    "QueRenTiXian": "Confirmer le retrait",
// goods-filter-tab
    "ZuiChangGouMai": "Les plus achetés",
    "MoRenPaiXu": "Tri par défaut",
    "ZongHe": "Combiné",
    "FenLei": "Catégorie",
    "XiaoLiangYouXian": "Priorité aux ventes",
    "XiaoLiang": "Ventes",
    "JiaGe": "Prix",
    "ShaiXuan": "Filtrer",
    "ZuiJinGouMai": "Achetés récemment",
    "CuXiaoYouXian": "Priorité aux promotions",
    "QuanBuFenLei": "Toutes les catégories",
    "ZhiKanCuXiao": "Voir seulement les promotions",
    "XuanZeFenLei": "Choisir la catégorie",
    "QXZFL": "Veuillez choisir la catégorie",
// goods-list-default
    "ZWXGSP": "Aucun produit lié",
// goods-brand-list
    "PinPaiHui": "Collection de marques",
// goods-classify-filter
    "TuiJianFenLei": "Catégories recommandées",
    "ShangPinFenLei": "Catégories de produits",
    "GengDuo": "Plus",
// goods-detail
    "DLZHBSDQQY": "Le compte connecté n'est pas le compte client entreprise actuel",
    "GXNHQ": "Félicitations, vous obtenez",
    "SZWSCJGH_C": "Partage possible uniquement après configuration du prix du mini-magasin",
    "JHDJSHS_": "Temps restant avant la fin de la promotion",
    "DLHKFX": "Partage possible après connexion",
    "ZZHQXX_QSH": "Récupération des informations en cours, veuillez réessayer plus tard",
    "Zhang": "pièce(s)",
    "Tian": "jour(s)",
    "QXZGGZQPD": "Veuillez d'abord choisir la spécification pour configurer l'éclairage !",
    "Yuan": "yuan",
    "XS_F_M": "heures/minutes/secondes",
// integral
    "WoDeJiFen": "Mes points",
    "DaBaiLe": "A vaincu",
    "JiFen": "Points",
    "DeHuiYuan": "des membres",
    "ZhuanJiFen": "Gagner des points",
    "JiFenMingXi": "Détails des points",
    "HuanLiPin": "Échanger contre des cadeaux",
    "CKGDHL": "Voir plus de cadeaux",
    "ChaDingDan": "Vérifier la commande",
// integral-convert
    "DHSLBNCG": "Le nombre d'échanges ne peut pas dépasser",
    "DuiHuanShuLiang": "Nombre d'échanges",
    "SuoXuJiFen": "Points nécessaires",
// integral-detail
    "LiPinXiangQing": "Détails du cadeau",
    "WoYaoDuiHuan": "Je veux échanger",
    "ShengYu": "Restant",
    "TuWenXiangQing": "Détails image-texte",
    "YiDuiWan": "Échangé complètement",
// integral-filter
    "FenLeiShaiXuan": "Filtrage par catégorie",
    "JiFenShaiXuan": "Filtrage par points",
// integral-flow
    "JiFenShouRu": "Revenus en points",
    "JiFenZhiChu": "Dépenses en points",
// integral-logistics
    "DingDanGenZong": "Suivi de la commande",
    "WuLiuGongSi": "Compagnie logistique",
    "WuLiuDanHao": "Numéro de suivi",
// integral-order
    "DingDanLieBiao": "Liste des commandes",
    "YiFaHuo": "Expédiée",
    "JiFenDingDan": "Commande en points",
    "ChaKanWuLiu": "Voir la logistique",
// integral-order-create
    "LPSLBZ_QCX": "Quantité de cadeaux insuffisante, veuillez payer à nouveau",
    "JiFenBuZu": "Points insuffisants",
    "ZhiFuXinXi": "Informations de paiement",
    "JiXuGuangGuang": "Continuer à parcourir",
    "QTXSHXX": "Veuillez saisir les informations de livraison",
    "DuiHuanChengGong": "Échange réussi",
    "LPDHQR": "Confirmation d'échange de cadeaux",
    "SCCKJ": "Prix de référence du marché",
    "LiJiZhiFu": "Payer immédiatement",
// integral-order-detail
    "DingDanXiangQing": "Détails de la commande",
    "DingDanZhuangTai": "Statut de la commande",
    "DingDanBianHao": "Numéro de commande",
    "DuiHuanShiJian": "Heure d'échange",
    "ShouHuoXinXi": "Informations de livraison",
    "HuaFeiJiFen": "Points dépensés",
// integral-rule
    "QDZJF": "Pointage pour gagner des points",
    "XDZJF": "Commander pour gagner des points",
    "DDWCHKHDYD": "Après achèvement de la commande, vous pouvez obtenir des points égaux au montant de la commande *",
    "1_MRQD_JL": "1. Pointage quotidien, récompense",
    "2_LXQD3T_EW": "2. Pointage continu pendant 3 jours, récompense supplémentaire",
    "3_LXQD7T_EW": "3. Pointage continu pendant 7 jours, récompense supplémentaire",
    "BeiDeJiFen": "fois les points",
    "DLZJF": "Se connecter pour gagner des points",
    "MeiRiDengLu": "Connexion quotidienne",
    "SC_JL": "magasin, récompense",
// integral-rule-detail
    "GuiZe": "Règles",
// integral-sign
    "QianDaoYouLi": "Pointage avec récompense",
    "QianDaoGuiZe": "Règles de pointage",
    "YLXQD": "Pointé en continu pendant",
    "QDCG_NYJLX": "Pointage réussi, vous avez pointé en continu pendant",
    "QDCG_BCHD": "Pointage réussi, cette fois vous obtenez",
    "QSRBZ": "Veuillez entrer une remarque",
    "DingDanZengPin": "Produit offert avec la commande",
    "GuiGeBianHao": "Référence de spécification",
    "GuiGe": "Spécification",
// combined-pay
    "CDDWXFK": "Cette commande ne nécessite pas de paiement",
    "YHYEBZ": "Solde utilisateur insuffisant !",
    "ZFJEBNW0": "Le montant du paiement ne peut pas être 0 !",
    "ZFJEBNDYDD": "Le montant du paiement ne peut pas être supérieur au montant à payer de la commande",
    "DFKJE": "Montant à payer",
    "FuKuanFangShi": "Mode de paiement",
    "FuJian": "Pièce jointe",
    "ZHYFZ": "Compte copié",
    "GHSKZH": "Changer le compte récepteur",
    "SYXXZFQSCF": "Pour le paiement offline, veuillez télécharger une capture d'écran du paiement en pièce jointe pour que les services financiers puissent confirmer le paiement !",
    "XXZF_BXXZS": "Paiement offline, vous devez choisir un compte récepteur",
    "DingDanZhiFu": "Paiement de la commande",
    "ZFFS_HDFK": "Mode de paiement : Paiement à la livraison",
    "BCFKJE": "Montant de ce paiement",
    "YuE": "Solde",
    "FuZhiZhangHao": "Copier le compte",
    "WSZXCXZFPZ": "Configuration de paiement par mini-programme non définie",
    "XCXZFZHJY": "Compte de paiement par mini-programme désactivé",
    "SRZFJE": "Entrer le montant du paiement",
    "FuKuanZhangHu": "Compte de paiement",
    "QueRenZhiFu": "Confirmer le paiement",
    "ShaoHouZhiFu": "Payer plus tard",
// order
    "FKJLYTJ_DD": "Enregistrement de paiement ajouté, en attente de vérification financière",
    "JiXuGuang": "Continuer à parcourir",
    "BenCiFuKuan": "Ce paiement",
    "FuKuanChengGong": "Paiement réussi",
    "ZhiFuFangShi": "Mode de paiement",
    "ZhiFuDingDan": "Commande de paiement",
// order-batch-pay
    "QXXZSXZFDD": "Veuillez d'abord sélectionner les commandes à payer",
    "PiLiangFuKuan": "Paiement en lot",
    "FuKuan": "Payer",
    "'QuFuKuan'": "Aller payer",
// order-create-result
    "YingFuJinE": "Montant à payer",
    "XiaDanShiJian": "Heure de commande",
// order-deliver
    "SFQRSH": "Voulez-vous confirmer la réception ?",
    "DDQRSH_": "Confirmer la réception de la commande ?",
    "DFHSP": "Produits en attente d'expédition",
    "ShangPinShuLiang": "Quantité de produits",
    "ChuKuShiJian": "Heure de sortie de stock",
    "FaHuoShiJian": "Heure d'expédition",
    "WuLiuBeiZhu": "Remarque sur la logistique",
    "QueRenShouHuo": "Confirmer la réception",
    "RYFK_QJSYG": "Si déjà payé, veuillez contacter l'administrateur en temps voulu",
    "QSRQXYY": "Veuillez entrer la raison de l'annulation",
    "H_DDJZDGB_QJKF": "plus tard, la commande sera automatiquement fermée, veuillez payer dès que possible",
    "TuiHuoQingKuang": "Situation des retours",
    "DingDanZongE": "Montant total de la commande",
    "DingDanBeiZhu": "Remarque sur la commande",
    "FaHuoQingKuang": "Situation de l'expédition",
    "DingDanFuJian": "Pièces jointes de la commande",
    "ShenQingTuiHuo": "Demander un retour",
    "G1TDSHJL_QRS": "Total {num} enregistrements en attente de réception, confirmer la réception ?",
    "DaiXiaDan": "Commander pour le client",
    "DingDanHao": "Numéro de commande",
    "XiaDanFangShi": "Mode de commande",
    "TuiHuoDan": "Bon de retour",
    "ShangPinZongE": "Montant total des produits",
    "YunFei_ZongZhong": "Frais de livraison (poids total",
    "SF_SPWS": "Taxe (produit sans taxe",
    "TePiJia": "Prix spécial",
    "FuKuanQingKuang": "Situation du paiement",
    "TiaoJiLu": "enregistrement(s)",
    "ZaiLaiYiDan": "Une autre commande",
    "QDSCGDD_": "Voulez-vous vraiment supprimer cette commande ?",
    "YiQueRen": "Confirmée",
    "YiShouHuo": "Reçue",
    "DaiFuJinE": "Montant à payer",
    "YiFuJinE": "Montant payé",
    "ZanWuJiLu": "Aucun enregistrement",
    "SPMC_DDH": "Nom du produit / Numéro de commande",
    "FuKuanZhuangTai": "Statut du paiement",
    "FaHuoZhuangTai": "Statut de l'expédition",
    "QiShiShiJian": "Heure de début",
    "ZhongZhiShiJian": "Heure de fin",
// order-list
    "CaoZuoChengGong": "Opération réussie",
    "ZBKGM": "Actuellement non disponible à l'achat",
    "DQDDSPYXJ": "Le produit de la commande actuelle a été retiré du ligne",
    "DQDDBFSPYXJ": "Certains produits de la commande actuelle ont été retirés du ligne",
    "JTJSJSP": "Ajouter uniquement les produits en ligne",
    "DingHuoDan": "Bon de commande",
// order-log
    "DingDanRiZhi": "Journal de commande",
// order-logistics
    "FuZhiChengGong": "Copié avec succès",
    "FuZhiShiBai": "Copie échouée",
    "FuZhi": "Copier",
    "BoDa": "Appeler",
    "WCWLDHXX": "Aucune information sur ce numéro de suivi",
// order-pay
    "ZFCS_QCXXD": "Paiement expiré, veuillez passer une nouvelle commande",
    "YQYYCKZF": "Paiement par précompte activé",
    "BNDYDFKJE": "Ne peut pas être supérieur au montant à payer",
    "ZFJEBNWK": "Le montant du paiement ne peut pas être vide",
    "QXAPFK_FKH": "Veuillez d'abord organiser le paiement, après paiement, téléchargez une capture d'écran des informations de paiement pour que les services financiers puissent confirmer le paiement",
    "DDTJCG_QJS": "Commande soumise avec succès, veuillez payer en temps voulu",
    "QXZFKFS": "Veuillez choisir le mode de paiement",
    "SYYEZFH_HX": "Après paiement par solde, il reste à payer",
//
    "FuKuanJiLu": "Enregistrements de paiement",
    "ZWFKJL": "Aucun enregistrement de paiement",
    "FuKuanXiangQing": "Détails du paiement",
    "FuKuanJinE": "Montant du paiement",
    "ZhiDan": "Créer",
    "ShenHe": "Vérifier",
    "ZuoFei": "Annuler",
    "ZuoFeiYuanYin": "Raison de l'annulation",
    "GLDHD": "Bon de commande associé",
    "HeXiaoJinE": "Montant de validation",
    "HeXiaoZhuangTai": "Statut de validation",
    "DanJuZhuangTai": "Statut du document",
    "KeHuMingCheng": "Nom du client",
    "ZhangDanHao": "Numéro de facture",
    "ShouKuanZhangHao": "Compte récepteur",
    "ShouKuanShiJian": "Heure de réception",
    "FuKuanPingZheng": "Justificatif de paiement",
    "GeFuJian": "pièce(s) jointe(s)",
// order-statistics
    "DingDanTongJi": "Statistiques de commandes",
    "DingHuo": "Commande",
    "Bi": "pièce(s)",
// order-statistics-detail
    "DDTJMX": "Détails des statistiques de commandes",
    "AGGTJ": "Statistiques par spécification",
    "AFLTJ": "Statistiques par catégorie",
    "DDJE_Y": "Montant de la commande/yuan",
    "DHSP_Z": "Produits commandés/type(s)",
    "DingHuoDan_Bi": "Bons de commande/pièce(s)",
    "DingHuoShangPin": "Produits commandés",
    "JinE": "Montant",
// refund-list
    "TuiHuo": "Retour",
// refund-apply
    "THDHWBC_QD": "Le bon de retour n'est pas encore enregistré, voulez-vous vraiment quitter ?",
    "QSRSQTHJE": "Veuillez entrer le montant de retour demandé",
    "QSRTHJE": "Veuillez entrer le montant de retour",
    "QSRBZXX": "Veuillez entrer des informations de remarque",
    "YingTuiJinE": "Montant à rembourser",
    "TJTHSQ": "Soumettre la demande de retour",
    "QXXZDHQD": "Veuillez d'abord sélectionner la liste de commandes",
    "DingHuoQingDan": "Liste de commandes",
    "SQTHJE": "Montant de retour demandé",
    "DJXZSP": "Cliquez pour sélectionner les produits",
    "TuiHuoJinE": "Montant de retour",
// refund-detail
    "THDDXQ": "Détails de la commande de retour",
    "YiTuiHuo": "Retourné",
    "YiTuiKuan": "Remboursé",
    "THDZT": "Statut du bon de retour",
    "TuiHuoDanHao": "Numéro de bon de retour",
    "TuiHuoShiJian": "Heure de retour",
    "TuiHuoCangKu": "Entrepôt de retour",
    "THLXR": "Contact pour le retour",
    "TuiHuoQingDan": "Liste de retours",
    "TuiKuanZongE": "Montant total de remboursement",
    "TuiKuanQingKuang": "Situation du remboursement",
    "DaiTuiJinE": "Montant à rembourser",
    "YiTuiJinE": "Montant remboursé",
// refund-product
    "SPMC_BH_GG": "Nom du produit / Référence / Référence de spécification / Code-barres",
    "GZD1TJG": "Total 1 résultat trouvé",
    "JiaRuQingDan": "Ajouter à la liste",
// refund-result
    "ShenQingChengGong": "Demande réussie",
    "THDTJCG": "Bon de retour soumis avec succès",
    "ChaKanXiangQing": "Voir les détails",
// goods-package-floor
    "HDWKS_WDZL": "La promotion n'a pas commencé, revenez plus tard",
    "HDYJS_XCZD": "La promotion est terminée, venez plus tôt la prochaine fois",
    "ZWSZBT": "Titre non défini pour le moment",
    "ChaKanGengDuo": "Voir plus",
// goods-promotion-floor
    "HCDZSJC": "Différence de temps due au cache",
    "DLCKCXJ": "Connectez-vous pour voir le prix promotionnel",
		    "ZWSZCX": "Aucune promotion définie pour le moment",
    "JuKaiShi": "Jusqu'au début",
    "Song": "Offrir",
    "JuJieShu": "Jusqu'à la fin",
    "YiJieShu": "Terminée",
// search-floor
    "XiaoXi": "Message",
    "SaoMaXiaDan": "Scanner et commander",
// home-page-custom
    "WZLCSJ": "Données d'étage inconnues",
// jump-error
    "QXZYSDHAPP": "Veuillez télécharger l'application Yunshang Order",
    "QMTYQYGLD": "Profitez pleinement de l'administration de l'entreprise",
    "XZYSDHAPP": "Télécharger l'application Yunshang Order",
    "HQGLDWZTY": "Obtenir l'expérience complète de l'administration",
    "JXTYDHD": "Continuer à utiliser la commande",
// notice-detail
    "GongGaoXiangQing": "Détails de l'annonce",
    "GongGaoFuJian": "Pièces jointes de l'annonce",
// shop-error
    "NFWDYMBCZO": "La page que vous visitez n'existe pas~",
    "KeNengYuanYin": "Causes possibles",
    "1_ZDZLSRCWD": "1. Adresse incorrecte entrée dans la barre d'adresse ;",
    "2_DJLGQLJ": "2. Lien expiré cliqué.",
// shop-index
    "GuanLiDuan": "Interface d'administration",
    "ZhuCe": "Inscrire",
    "HYNTYYSDH": "Bienvenue à l'expérience Yunshang Order",
    "TYZHSJHDQG": "Les données du compte d'essai seront mises à jour régulièrement, veuillez ne pas entrer d'informations importantes",
    "TYZHZDNRSJ": "Les contenus et données du compte d'essai sont fictifs, veuillez ne pas entrer d'informations importantes",
    "ZHZCCG": "Compte inscrit avec succès",
    "DengLuZhangHao": "Compte de connexion",
    "CSMMW": "Le mot de passe initial est",
    "GNFYHQL": "Des coupons vous ont été envoyés",
    "Man1YuanKeYong": "Utilisable à partir de {num} yuan",
    "LQH1TNKY": "Utilisable dans {day} jours après avoir obtenu le coupon",
    "YiJianLingQu": "Obtenir en un clic",
    "GXNHD1ZYHQ": "Félicitations, vous avez obtenu 1 coupon",
    "Gong1Yuan": "Total 1 yuan",
    "LiJiShiYong": "Utiliser immédiatement",
// shop-login
    "NHWDL": "Vous n'êtes pas connecté",
// shop-notice
    "ShangChengGongGao": "Annonces du magasin",
    "ZanWuGongGao": "Aucune annonce",
    "1GeFuJian": "{num} pièce(s) jointe(s)",
// deposit-detail
    "KouKuan": "Débit",
    "ChongZhi_Kuan": "Recharge",
    "KouKuanZuoFei": "Débit annulé",
    "ChongZhiZuoFei": "Recharge annulée",
    "ZhangHuMingXi": "Détails du compte",
    "ZhangHuYuE": "Solde du compte",
    "LiJiChongZhi": "Recharger immédiatement",
// deposit-recharge
    "CZJEBNXY1Y": "Le montant de recharge ne peut pas être inférieur à 1 yuan",
    "QSRZQDSZ": "Veuillez entrer une valeur correcte",
    "ZDYJE": "Montant personnalisé",
    "ZWKTXSCZGN": "Fonction de recharge en ligne non activée pour le moment",
    "ShiFuJinE": "Montant payé réel",
    "ZhangHuChongZhi": "Recharge du compte",
    "QXZCZJE": "Veuillez choisir le montant de recharge",
    "QSRCZJE": "Veuillez entrer le montant de recharge",
    "QLXNDZSYWY": "Veuillez contacter votre commercial dédié pour recharger",
    "ShouJia": "Prix de vente",
    "YiShouQing": "Épuisé",
    "ChongZhiJinE": "Montant de recharge",
    "QueRenFuKuan": "Confirmer le paiement",
// deposit-recharge-result
    "QSDDID": "ID de commande manquant",
    "ChongZhiChengGong": "Recharge réussie",
    "ChongZhiShiBai": "Recharge échouée",
    "CLZ_QSH...": "En traitement, veuillez patienter...",
    "ChongZhiFangShi": "Mode de recharge",
    "ChongZhiShiJian": "Heure de recharge",
    "JYLSH": "Numéro de transaction",
    "FanHuiShangCheng": "Retour au magasin",
// recharge-online
    "ZFSB_QCS": "Paiement échoué, veuillez réessayer",
    "ZFYQX": "Paiement annulé",
    "ZFYC_QCS": "Paiement anormal, veuillez réessayer",
// user
    "LingQuanZhongXin": "Centre de coupons",
    "WeiShiYong": "Non utilisé",
    "YiShiYong": "Utilisé",
    "ZWYHQ": "Aucun coupon",
// keep-list
    "YiGouMai": "Acheté",
    "ChangYongQingDan": "Liste fréquemment utilisée",
    "WoDeShouCang": "Mes favoris",
    "QuGouWuChe": "Aller au panier",
    "GeShangPin": "produit(s)",
// login
    "YunShangDingHuo": "Yunshang Order",
    "QSRZH": "Veuillez entrer le compte !",
    "QSRMM": "Veuillez entrer le mot de passe !",
    "QSRDLZH": "Veuillez entrer le compte de connexion",
    "JiZhuMiMa": "Mémoriser le mot de passe",
    "WangJiMiMa": "Mot de passe oublié ?",
    "DengLu": "Se connecter",
    "DLZHBCZ_QL": "Compte de connexion inexistant, veuillez contacter l'administrateur pour l'activer",
    "GQYZHSBJY_": "Ce compte entreprise est désactivé, veuillez contacter Yunshang Order",
    "GQYZHSYQJS_": "La période d'essai du compte entreprise est terminée, veuillez contacter Yunshang Order",
    "GQYZHYGQL_": "Ce compte entreprise est expiré, un renouvellement est nécessaire pour l'utiliser, veuillez contacter Yunshang Order",
    "LiJiTiYan": "Essayer immédiatement",
// my-collect
    "YiChuChengGong": "Supprimé avec succès",
    "QueHuo": "En rupture de stock",
    "YCSCJ": "Supprimer des favoris",
// order-message
    "SheZhiChengGong": "Paramètres enregistrés avec succès",
    "ZWWDXX": "Aucun message non lu",
    "QuanBuYiDu": "Tout marquer comme lu",
    "DingDanXiaoXi": "Message de commande",
    "YiQiang": "A été pris",
    "LiJiLingQu": "Obtenir immédiatement",
    "LingQuanHou": "Après avoir obtenu le coupon",
    "TianNeiKeYong": "utilisable dans jours",
    "QSRSJH": "Veuillez entrer le numéro de téléphone",
    "QSRYZM": "Veuillez entrer le code de vérification",
    "QSRXMM": "Veuillez entrer le nouveau mot de passe",
    "QSRZQSJGS": "Veuillez entrer un format de téléphone correct",
    "ChongZhiMiMa": "Réinitialiser le mot de passe",
    "QSRNDSJHM": "Veuillez entrer votre numéro de téléphone",
    "QSRDXYZ": "Veuillez entrer la vérification par SMS",
    "HQYZM": "Obtenir le code de vérification",
    "HKCXHQ": "peut être obtenu à nouveau après",
    "QSR6_20WSZHZ": "Veuillez entrer un mot de passe de 6 à 20 chiffres ou lettres",
// share-setting
    "QSRSPJGBL": "Veuillez entrer le taux de prix du produit",
    "SPJGBLBXDY": "Le taux de prix du produit doit être supérieur ou égal à 100 et inférieur à 999.99",
    "DPMCZBZCTS": "Le nom du magasin ne prend pas en charge les caractères spéciaux pour le moment",
    "LXRZBZCTSF": "Le contact ne prend pas en charge les caractères spéciaux pour le moment",
    "LXFSZBZCTS": "Les informations de contact ne prennent pas en charge les caractères spéciaux pour le moment",
    "LXDZZBZCTS": "L'adresse de contact ne prend pas en charge les caractères spéciaux pour le moment",
    "DPJJZBZCTS": "La description du magasin ne prend pas en charge les caractères spéciaux pour le moment",
    "QSRDPJJ_ZD": "Veuillez entrer la description du magasin, maximum 50 caractères",
    "FenXiangSheZhi": "Paramètres de partage",
    "NDWSCSPJG": "Prix des produits de votre mini-magasin",
    "NDDHJ_": "Votre prix de commande ×",
    "LXXX_KBJ_": "Informations de contact (modifiable)",
    "DianPuMingCheng": "Nom du magasin",
    "JianJie": "Description",
    "QSRDPMC": "Veuillez entrer le nom du magasin",
    "LianXiRen": "Contact",
    "QSRLXR": "Veuillez entrer le contact",
    "LianXiFangShi": "Mode de contact",
    "QSRLXFS": "Veuillez entrer le mode de contact",
    "LianXiDiZhi": "Adresse de contact",
    "QSRLXDZ": "Veuillez entrer l'adresse de contact",
// user
    "WoDeDingDan": "Mes commandes",
    "ZuiJinLiuLan": "Vus récemment",
    "ShouCangShangPin": "Produits favoris",
    "BDYYZH_ZC": "Lier un compte existant | Inscrire un nouveau compte",
    "DL_ZC": "Se connecter | S'inscrire",
    "BangDingShouJi": "Lier le téléphone",
    "TS_BDSJHM_": "Remarque : Lier votre numéro de téléphone rend le compte plus sécurisé !",
    "ChaKanQuanBu": "Voir tout",
    "ShouHuoDiZhi": "Adresse de livraison",
    "LianXiWoMen": "Contactez-nous",
    "SheZhi": "Paramètres",
    "QuQianDao": "Aller au pointage",
    "JiFenShangCheng": "Magasin de points",
    "TuiGuangShangPin": "Promouvoir le produit",
    "QuChaKan": "Aller voir",
    "JiFenHuanLi": "Échanger des points contre des cadeaux",
    "DYSPBQ": "Imprimer l'étiquette du produit",
// user-about
    "GYYSDH": "À propos de Yunshang Order",
    "YQHYSMEWM_": "Invitez des amis à scanner le code QR pour télécharger et installer directement",
    "DangQianBanBen": "Version actuelle",
// user-address
    "ZWSHDZ": "Aucune adresse de livraison",
    "WoDeDiZhi": "Mes adresses",
    "ZhiNengShiBie": "Reconnaissance intelligente",
    "ZTDZXXKZNS": "Collez les informations d'adresse pour reconnaître automatiquement le nom, le téléphone et l'adresse",
    "MoRen": "Par défaut",
    "QRSCDZ": "Voulez-vous vraiment supprimer l'adresse ?",
    "SHRXM": "Nom du destinataire",
    "SJHMHGDDHZ": "Au moins un numéro de téléphone portable ou fixe doit être rempli",
    "QSRSHRXM": "Veuillez entrer le nom du destinataire",
    "ShouJiHaoMa": "Numéro de téléphone portable",
    "GuDingDianHua": "Numéro de téléphone fixe",
    "QSRGDDH": "Veuillez entrer le numéro de téléphone fixe",
    "SuoZaiDiQu": "Région",
    "QSRSZDQ": "Veuillez entrer la région",
    "QSRXXDZ": "Veuillez entrer l'adresse détaillée !",
    "QSRZQDSJHM": "Veuillez entrer un numéro de téléphone portable correct",
    "QSRZQDGDDH": "Veuillez entrer un numéro de téléphone fixe correct",
    "XiangXiDiZhi": "Adresse détaillée",
    "MoRenDiZhi": "Adresse par défaut",
    "SWMRDZ": "Définir comme adresse par défaut",
    "BCBSY": "Enregistrer et utiliser",
// user-bing-one
    "QSRSJHM": "Veuillez entrer le numéro de téléphone",
    "GYHYZC": "Cet utilisateur est déjà inscrit",
    "GSJHMYJZCG": "Ce numéro de téléphone a déjà été inscrit",
    "QZJDLJK": "Veuillez directement vous connecter",
    "QuDengLu": "Aller se connecter",
    "BDHKYTGSJH": "Après liaison, vous pouvez vous connecter via le numéro de téléphone, ce qui facilite la récupération de votre mot de passe et améliore la sécurité du compte",
    "_BDHKYTGSJ": "*Après liaison, vous pouvez vous connecter via le numéro de téléphone, ce qui facilite la récupération de votre mot de passe et améliore la sécurité du compte",
    "QSRSJYZM": "Veuillez entrer le code de vérification du téléphone",
    "BDXSJ": "Lier un nouveau téléphone",
    "DXYZM": "Code de vérification SMS",
    "XiaYiBu": "Suivant",
    "TGCBZ": "Passer cette étape",
// user-bing-two
    "DBDSJHMBCZ": "Le numéro de téléphone à lier n'existe pas !",
    "QSRDLMM": "Veuillez entrer le mot de passe de connexion !",
    "_GSJHMYBDY": "*Ce numéro de téléphone est déjà lié à un compte Yunshang Order, vérifiez le mot de passe de connexion du téléphone pour lier le compte actuel",
    "DQZHMMJTBW": "Le mot de passe du compte actuel sera synchronisé comme mot de passe de connexion du téléphone",
    "DangQianZhangHao": "Compte actuel",
//
    "QDYJZ": "Voulez-vous vraiment supprimer ces",
    "JSPSCM": "produit(s) ?",
    "ShanChuChengGong": "Suppression réussie !",
// user-info
    "SJGSCW": "Format de téléphone incorrect",
    "YXGSCW": "Format de courriel incorrect",
    "WoDeZhangHao": "Mon compte",
    "YouXiang": "Courriel",
    "ShouJi": "Téléphone",
    "XingMing": "Nom",
    "XiuGaiTouXiang": "Modifier l'avatar",
    "JiBenXinXi": "Informations de base",
    "ZhangHaoAnQuan": "Sécurité du compte",
    "XiuGaiMiMa": "Modifier le mot de passe",
    "DianJiBangDing": "Cliquez pour lier",
    "RYDSHTY_QL": "Si perdu ou désactivé, remplacez-le immédiatement pour éviter le vol de compte",
    "WBZNDZHAQ_": "Pour assurer la sécurité de votre compte, veuillez lier votre téléphone",
    "QSRNDXM": "Veuillez entrer votre nom",
    "QSRNDDH": "Veuillez entrer votre téléphone",
    "QSRNDYX": "Veuillez entrer le courriel",
// user-setting
    "QCHCHXCXDL": "Une reconnexion est nécessaire après la suppression du cache",
    "QingChuHuanCun": "Supprimer le cache",
    "QDYQCHCM": "Voulez-vous vraiment supprimer le cache ?",
    "TuiChuDengLu": "Se déconnecter",
    "QieHuanZhangHao": "Changer de compte",
// user-supplier
    "LianXi": "Contact",
    "GongSiDianHua": "Téléphone de l'entreprise",
    "DiZhi": "Adresse",
// vouchers-detail
    "DJQMX": "Détails du bon d'achat",
// vouchers-list
    "BuKeYong": "Inutilisable",
    "KeYong": "Utilisable",
    "ZWDJQ": "Aucun bon d'achat",
    "ZongEDu": "Montant total",
    "FaFangShiJian": "Heure de distribution",
    "EDYYW": "Montant épuisé",
    "QBSPKY": "Utilisable pour tous les produits",
// vouchers-select-list
    "WDDJQ": "Mes bons d'achat",
    "KYDJQ": "Bons d'achat utilisables",
    "DJQKDK": "Bon d'achat peut déduire",
    "CKKYSP": "Voir les produits utilisables",
    "BKYDJQ": "Bons d'achat inutilisables",
    "BKYYY_ZWFH": "Raison d'inutilisabilité : Aucun produit correspondant",
// goods-detail
    "DQSPWSCGGT": "Aucune image de spécification n'a été téléchargée pour ce produit, la configuration d'éclairage n'est pas prise en charge !",
    "BoFangShiPin": "Lire la vidéo",
    "Gong1GeGuiGe": "Total {num} spécification(s)",
    "YiXuanGuiGe": "Spécification sélectionnée",
    "XuanGuiGe": "Choisir la spécification",
    "LingQuan": "Obtenir le coupon",
    "1ZhongCuXiao": "1 type de promotion",
    "1ZhangKeYong": "1 utilisable",
    "ZuiGaoKeSheng": "Économies maximales",
    "ShangPinTaoCan": "Pack de produits",
    "Gong1GeTaoCan": "Total 1 pack",
    "ShangPinCanShu": "Paramètres du produit",
    "ZhanKai": "Déplier",
    "YiShouCang": "Déjà dans les favoris",
    "ShouCang": "Ajouter aux favoris",
    "KeFu": "Service client",
    "XiangQing": "Détails",
    "TuiJian": "Recommandé",
    "BianHao": "Référence",
    "ShangPinXinXi": "Informations sur le produit",
    "KLYHQ": "Coupons disponibles",
    "KuCunBuZu": "Stock insuffisant",
    "DuoGuiGe": "Multiples spécifications",
    "YiShou": "Vendu",
    "SWBHZ_YS": "En cours de réapprovisionnement, vendu",
    "CuXiaoShangPin": "Produit en promotion",
// goods-search
    "NHWSRSSNR": "Vous n'avez pas encore entré de contenu de recherche",
    "SouSuo": "Rechercher",
    "SSY1XGDSP": "Rechercher des produits liés à {searchKey}",
    "Yue1GeShangPin": "Environ {num} produit(s)",
    "ZuiJinSouSuo": "Recherches récentes",
    "QingChu": "Effacer",
    "ZWSSJL": "Aucun historique de recherche",
// goods-property
    "ZGJGBNDYZD": "Le prix le plus élevé ne peut pas être inférieur au prix le plus bas",
    "ShangPinBiaoQian": "Étiquette de produit",
    "BuGaoYu1": "Pas supérieur à 1",
    "BuDiYu1": "Pas inférieur à 1",
    "FengGe": "Style",
// goods-promotion-list
    "JiJiangKaiShi": "Va commencer",
    "QuanBuCuXiao": "Toutes les promotions",
// goods-package-list
    "Gong1JianShangPin": "Total 1 produit",
    "Sheng": "Économiser",
// goods-package-detail
    "GTCZGWCZDS": "Le nombre de packs dans le panier a atteint la limite d'achat, impossible de l'ajouter au panier",
    "GTCKCBZ_BK": "Stock de pack insuffisant, impossible d'ajouter au panier",
    "JinSheng1Tao": "Il ne reste qu'1 set",
    "XianGou1Tao": "Limite d'achat 1 set",
    "TaoCanXiangQing": "Détails du pack",
    "DanMaiJia": "Prix à l'unité",
    "TaoCanJia": "Prix du pack",
    "HDYJS": "Promotion terminée",
// goods-message
    "WDL_QXDL": "Non connecté, veuillez d'abord vous connecter",
// goods-list-label
    "XinPinShangShi": "Nouveautés",
    "WDLZH_ZWCX": "Compte non connecté, aucune promotion pour le moment !",
    "YiXiaShangPin": "Produits suivants",
// goods-list
    "1ZhongGuiGe": "1 spécification",
    "YouKuCun": "En stock",
// goods-filter
    "BuGaoYu": "Pas supérieur à",
    "BuDiYu": "Pas inférieur à",
    "CuXiao": "Promotion",
    "ZDYXXZ3G": "Maximum 3 sélections autorisées",
    "GouMai": "Acheter",
    "Gong1Jian": "Total {num} article(s)",
// 已订货商品
    "DLHCKJG": "Voir le prix après connexion",
    "M1JZ1J": "À partir de {num} articles, offert {presentNum} articles",
    "CZPF_ZZCXC": "Opération trop fréquente, nouvelle tentative en cours",
    "XSZJJXZ": "Réduction directe limitée dans le temps en cours",
    "YXSPM1YZ1J_": "Produits suivants {str}, ajoutez au panier et payez pour bénéficier des offres !",
    "TiaoXingMa": "Code-barres",
    "XiangGuanTuiJian": "Recommandations liées",
    "YSSPBKJRGW": "Les produits en prévente ne peuvent pas être ajoutés au panier, des produits non en prévente ont été ajoutés pour vous !",
    "YSSPBKLJGM": "Les produits en prévente ne peuvent pas être achetés immédiatement, veuillez supprimer les produits en prévente et réacheter !",
    "SPSLYW": "Quantité de produit incorrecte",
    "ShangPin1QiShou": "Produit {num} à partir de",
    "SPDGSLBNCG": "La quantité commandée de produit ne peut pas dépasser {num}",
    "QRYCXZSP": "Confirmer la suppression des produits sélectionnés",
    "QRYCSYSXSP": "Confirmer la suppression de tous les produits invalides",
    "QRYCXZSXSP": "Confirmer la suppression des produits invalides sélectionnés",
    "M1YZ1J": "À partir de {num} yuan, offert {presentNum} articles",
    "M1YJ1Y": "À partir de {price} yuan, réduction de {money} yuan",
    "M1J1": "À partir de {price}, réduction de {money}",
    "M1YD1Z": "À partir de {price} yuan, remise de {money}%",
    "DDM1YHZ": "Commande d'un montant de {price} yuan, offert",
    "YiHuoZeng": "Déjà offert",
    "ZG1YLXM1YZ1": "Achetez encore {price} yuan pour bénéficier de {str}",
    "ZG1JLXM1JZ1": "Achetez encore {num} articles pour bénéficier de {str}",
    "QCSXSP": "Supprimer les produits invalides",
    "YiXuanShangPin": "Produits sélectionnés",
    "QuJieSuan": "Aller au règlement",
    "ShiXiaoShangPin": "Produits invalides",
    "DingDanGuanLi": "Gestion des commandes",
    "ZhuangTai": "Statut",
    "ShangPinChuKu": "Produit en sortie de stock",
    "DengDaiShouHuo": "En attente de réception",
    "PeiSongXinXi": "Informations de livraison",
    "FuKuanXinXi": "Informations de paiement",
    "GDFKJL": "Plus d'enregistrements de paiement",
    "WuLiuFuJian": "Pièces jointes de logistique",
    "ZanWuFuJian": "Aucune pièce jointe",
    "YiFa": "Envoyé",
    "YingFuZongE": "Montant total à payer",
    "FuKuanShiJian": "Heure de paiement",
    "ZhangHuHaoMa": "Numéro de compte",
    "KeYongYuE": "Solde utilisable",
    "TianJiaChengGong": "Ajouté avec succès",
    "ShanChuDiZhi": "Supprimer l'adresse",
    "QXZSHDZ": "Veuillez choisir une adresse de livraison",
    "YiHuoZengPin": "Produits offerts déjà obtenus",
    "YiYouHui1Yuan": "Déjà économisé {money} yuan",
    "QWSFPXX": "Veuillez compléter les informations de facture",
    "1ZSP": "{num} type(s) de produit(s)",
    "Gong": "Total",
    "Jian": "article(s)",
    "ShangPinJinE": "Montant du produit",
    "YunFeiDaoFu": "Frais de livraison à la livraison",
    "QSRZQDSHRX": "Veuillez entrer un nom de destinataire correct",
    "QSRZQDXXDZ": "Veuillez entrer une adresse détaillée correcte",
    "DBQ_MYZDDY": "Désolé, aucune page correspondante trouvée",
    "ShouHuoChengGong": "Réception réussie",
    "Hi_HuanYingNin": "Hi, bienvenue",
    "YiFaEWuLiu": "e-logistique envoyée",
    "NinDeDingDan": "Votre commande",
    "ZBNBHBQ": "ne peut contenir d'émojis",
    "XMBNWK": "Le nom ne peut pas être vide",
    "XiTongSheZhi": "Paramètres du système",
    "ZhangHaoXinXi": "Informations du compte",
    "QingShuRuXingMing": "Veuillez entrer le nom",
    "QWSZL_JZYG": "Veuillez compléter les informations pour bénéficier d'une meilleure service",
    "QSRZQDYXGS": "Veuillez entrer un format de courriel correct",
    "QTXZQDCWXX": "Veuillez remplir correctement les informations financières pour que votre partenaire puisse vous émettre une facture",
    "GXSHDZCG": "Adresse de livraison mise à jour avec succès",
    "BCSHDZCG": "Adresse de livraison enregistrée avec succès",
    "XinZengDiZhi": "Ajouter une adresse",
    "QXZYQXSCDS": "Veuillez choisir les produits dont vous souhaitez annuler les favoris",
    "QuXiaoShouCang": "Annuler les favoris",
    "XuanZeGuiGe": "Choisir la spécification",
    "CaiWuGuanLi": "Gestion financière",
    "DuiZhangMingXi": "Détails de reconciliation",
    "QSRLWJL_JE": "Veuillez entrer les enregistrements de contact/montant",
    "YiGouMai1Ci": "Acheté {count} fois",
    "6_1GouMai": "{time} achat",
    "TZGGXQ": "Détails de l'annonce de notification",
    "ZYXSCSP": "Seules les vidéos sont autorisées",
    "SCSPDXBYXC": "La taille de la vidéo téléchargée ne peut pas dépasser {size}",
    "YDHSP": "Produits déjà commandés",
    "ShangPinPinPai": "Marque de produit",
    "ShangPinLieBiao": "Liste de produits",
    "LingShouJia": "Prix de détail",
    "YouHuiJia": "Prix promotionnel",
    "LiJiGouMai": "Acheter immédiatement",
    "ZhuTu": "Image principale",
    "WuXianZhi": "Illimité",
    "XiaoJi": "Sous-total",
    "SCXZSP": "Supprimer les produits sélectionnés",
    "QSRDDH": "Veuillez entrer le numéro de commande",
    "QSRDDH_SPMC": "Veuillez entrer le numéro de commande/nom de produit",
    "CaoZuo": "Opération",
    "WuLiuXinXi": "Informations de logistique",
    "CaoZuoLeiXing": "Type d'opération",
    "CaoZuoRiZhi": "Journal d'opérations",
    "CaoZuoShiJian": "Heure d'opération",
    "ZhangHuMingCheng": "Nom du compte",
    "KaiHuYinHang": "Banque d'ouverture",
    "DDTJCG_XZZC": "Commande soumise avec succès, il ne reste plus qu'une dernière étape",
    "ZhiFuJinE": "Montant du paiement",
    "DZFJE": "Montant à payer",
    "QTXYXSMB": "Entrez quelques explications",
    "XZSKYHZH": "Choisir le compte bancaire récepteur",
    "TiShi": "Remarque",
    "NHY1GDDGJ1Y": "Vous avez encore {num} commandes totalisant {money} yuan impayées",
    "QKJQHCKJXX": "Vous pouvez continuer à commander uniquement après règlement des dettes",
    "HDDDXX": "Vérifier les informations de commande",
    "BJSHDZ": "Modifier l'adresse de livraison",
    "TongZhiGongGao": "Annonces de notification",
    "YinHangZhangHao": "Numéro de compte bancaire",
    "XiuGaiShouJi": "Modifier le téléphone",
    "LXRXX": "Informations de contact",
    "GSCWXX": "Informations financières de l'entreprise",
    "QSRKHYHMCJ": "Veuillez entrer le nom de la banque d'ouverture et la succursale",
    "QSRYHZH": "Veuillez entrer le numéro de compte bancaire",
    "PiLiangCaoZuo": "Opération en lot",
    "GouMaiJiLu": "Historique d'achats",
    "TongZhiBiaoTi": "Titre de notification",
    "FaBuShiJian": "Heure de publication",
    "XiaoXiLeiXing": "Type de message",
    "XiaoXiNeiRong": "Contenu du message",
    "JieShouShiJian": "Heure de réception",
    "QuanBuPinPai": "Toutes les marques",
    "WXSYS_DHGBJ": "Scannez avec WeChat pour commander plus facilement",
    "GZWXGZH": "Suivez le compte officiel WeChat",
    "FuWuReXian": "Ligne de service",
    "SouSuoLiShi": "Historique de recherche",
    "QuanBuShanChu": "Tout supprimer",
    "NH_HYLDYSDH": "Bonjour, bienvenue chez {company} !",
    "ZSJDH": "Commander sur le téléphone",
    "SYS_GZWXGZH": "Scannez pour suivre le compte officiel WeChat",
    "GuanZhuWoMen": "Suivez-nous",
    "QBSPFL": "Toutes les catégories de produits",
    "QuPeiDeng": "Aller configurer l'éclairage",
    "KuanXiang": "Montant",
    "QSRSPMC_GG_": "Veuillez entrer le nom du produit/spécification/référence/première lettre",
    "NH_HYLDYSD": "Bonjour, bienvenue au magasin Yunshang Order !",
    "ReXiao": "Populaire",
    "20Tiao_Ye": "20 par page",
    "ShiChangJia_": "Prix du marché :",
    "_134.10Qi": "Desde S/ 134.10",
    "HJ_BHYF": "Total (hors frais de livraison) :",
    "QDSCXZSP_": "Voulez-vous vraiment supprimer les produits sélectionnés ?",
    "QDQCXJSP_": "Voulez-vous vraiment supprimer les produits retirés du ligne ?",
    "DDTJCG_XZZ": "Commande soumise avec succès, il ne reste plus qu'une dernière étape !",
    "XuanZeZhangHu": "Choisir le compte",
    "DaiZhiFu": "À payer",
    "CaiGouDingDan": "Commande d'achat",
    "DingDanXinXi": "Informations de commande",
    "TuiChu": "Quitter",
    "KaiHuMingCheng": "Nom de la banque d'ouverture",
    "QSRKHMC": "Veuillez entrer le nom de la banque d'ouverture",
    "_QTXZQDCWX": " (Veuillez remplir correctement les informations financières pour que votre partenaire puisse vous émettre une facture)",
    "ShouHuoRen": "Destinataire",
    "SWMRSHDZ": "Définir comme adresse de livraison par défaut",
    "TianJiaDiZhi": "Ajouter une adresse",
    "Gong4GeGuiGe": "Total 4 spécifications",
    "Zhi": "Seulement",
    "Kuai": "morceau",
    "Tou": "tête",
    "Xiang": "boîte",
    "Ping": "bouteille",
    "KaiShiRiQi": "Date de début",
    "JieShuRiQi": "Date de fin",
    "YiXuan": "Sélectionné",
    "ZhiFuZhuangTai": "Statut de paiement",
    "QDLCKJG": "Veuillez vous connecter pour voir le prix",
    "YZMBZQ": "Code de vérification incorrect",
    "ZhiFuJiLu": "Historique de paiement",
    "ShangPinMingCheng": "Nom du produit",
    "DingGouShuLiang": "Quantité commandée",
    "TuiHuoShuLiang": "Quantité retournée",
    "QSRTHNR": "Veuillez entrer le contenu du retour",
    "SCTHSM": "Télécharger l'explication du retour",
    "ShenQingShiJian": "Heure de demande",
    "ShenQingJinE": "Montant de la demande",
    "TuiHuoYuanYin": "Raison du retour",
    "TuiHuoShuoMing": "Explication du retour",
    "TuiDanHao": "Numéro de bon de retour",
    "SXCZ_XDCG": "Crédit suffisant, commande réussie",
    "SXEDBZ_FKHFH": "Crédit insuffisant, expédition après paiement",
    "CGJKZQ_FKFH": "Dépassement de la période de prêt, expédition après paiement",
    "DDTJCG_XZZCZHYB": "Commande soumise avec succès, il ne reste plus qu'une dernière étape !",
    "QNZ_NWCFK_FZ": "Veuillez compléter le paiement dans {time}, sinon la commande sera automatiquement annulée.",
    "MianFeiLing": "Obtenir gratuitement",
    "M_KMFLQ_HQ": "Obtenez gratuitement à partir de {target} yuan, il manque encore {short} yuan",
    "YHDMFSP": "Produits gratuits déjà obtenus",
    "JRMFL": "Obtenir gratuitement aujourd'hui",
    "LingGuangLe": "Epuisé",
    "KeLingQu": "Obtenable",
    "QSRZFJE": "Veuillez entrer le montant du paiement",
    "QNJKFK_WMJKWNCL": "Veuillez payer dès que possible, nous traiterons votre commande rapidement !",
    "XianXiaTiYanGuan": "Boutique d'expérience offline",
    "QingXuanZheSheng": "Veuillez choisir la province",
    "QingXuanZheShi": "Veuillez choisir la ville",
    "ZhanGuanDiZhi": "Adresse du pavillon",
    "YingYeShiJian": "Heures d'ouverture",
    "ZhanGuanDianHua": "Téléphone du pavillon",
    "FenXiang": "Partager",
    "TiYanGuanJieShao": "Description de la boutique d'expérience",
    "DPYDY_QSHX": "Le magasin est fermé, veuillez commander plus tard",
    "DaYangShiJian": "Heure de fermeture",
    "IMEI": "Numéro de série",
    "FanKuanYuE": "Solde de remboursement",
    "FanKuanZhiFu": "Paiement de remboursement",
    "YiShengZhiFu": "Paiement Yisheng",
    "JiongDongShouYinTai": "Caisse JD",
    "FKYEBZ": "Solde de remboursement insuffisant",
    "FanKuanZhangHu": "Compte de remboursement",
    "HaiXuZhiFu": "Il reste à payer {price}",
    "FaPiaoMingXi": "Détails de la facture",
    "FaPiaoZhuShou": "Assistant de facturation",
    "WoDeFaPiao": "Mes factures",
    "FaPiaoXiangQing": "Détails de la facture",
    "KaiPiaoShiJian": "Heure de facturation",
    "DaiKaiFaPiao": "Factures en attente",
    "DKFPJE": "Montant de factures en attente",
    "KaiPiaoJinE": "Montant de la facture",
    "GuanLianDanHao": "Numéro lié",
    "ChuangJianShiJian": "Heure de création",
    "ZhiFuPingZheng": "Justificatif de paiement",
    "QSRZQNR": "Veuillez entrer un contenu correct",
    "QSRTDH_SPMC": "Veuillez entrer le numéro de bon de retour/nom de produit",
    "ShangPinRuKu": "Entrée de produit en stock",
    "TuiKuanChuLi": "Traitement du remboursement",
    "YuanDingDanHao": "Numéro de commande original",
    "TuiHuoXinXi": "Informations de retour",
    "TuiKuanXinXi": "Informations de remboursement",
    "TuiKuanZhuangTai": "Statut de remboursement",
    "ZWTKJL": "Aucun enregistrement de remboursement",
    "GDTKJL": "Plus d'enregistrements de remboursement",
    "DDDKFQRBJQSH": "La commande attend la confirmation du prix par le service client, veuillez patienter",
    "BNSRDYHDTSZF": "Les guillemets simples et autres caractères spéciaux ne sont pas autorisés",
    "THSLBNWK": "La quantité de retour ne peut pas être vide",
    "BZBNBHBQ": "Les remarques ne peuvent pas contenir d'émojis",
    "THSLBKDYKTHSL": "La quantité de retour est supérieure à la quantité retournable",
    "DDM_YZ_J": "Commande d'un montant de {target} yuan, offert {number} articles",
    "M_JZ_J": "À partir de {target} articles, offert {number} articles",
    "M_JJZ_Y": "À partir de {target} articles, réduit à {money} yuan",
    "YDHJJZ_Y": "Prix de commande original réduit à {price} yuan",
    "M_JD_Z": "À partir de {number} articles, remise de {percent}%",
    "YDHJD_Z": "Prix de commande original avec remise de {percent}%",
    // Mercado Pago支付
    "WDSYT": "Ma caisse",
    "ZZSYMPSMJY": "Utilisation de transaction par scan Mercado Pago",
    "SKF": "Destinataire du paiement",
    "SYSFK": "Scannez pour payer",
    "DDXQ": "Détails de la commande",
    "YUAN": "yuan",
    // 优惠券
    "GXNHQ_Z_Y_": "Félicitations, vous obtenez {num} {price} yuan {name}",
    "QBLX": "Tous les types",
    "QLQZX": "Aller au centre de coupons",
    "YLYH": "Offres déjà obtenues",
    "MZTJJKSY": "Utilisable si les conditions sont remplies",
    "GXNHD_Z_YHQ": "Félicitations, vous avez obtenu {num} coupons",
    "G_Y": "Total {price} yuan",
    "XZYHQ": "Choisir le coupon",
    "PLXD": "Commande en lot",
    "FHJL": "Historique d'expédition",
    "DDTJ": "Statistiques de commandes",
    "DDGL": "Gestion des commandes",
    "JKWFH": "Voir seulement les non expédiés",
    "DDS": "Nombre de commandes",
    "DGSPS": "Nombre de produits commandés",
    "THSPS": "Nombre de produits retournés",
    "YFHSPS": "Nombre de produits expédiés",
    "WFHSPS": "Nombre de produits non expédiés",
    "YFHSPJE": "Montant de produits expédiés",
    "WFHSPJE": "Montant de produits non expédiés",
    "WFH": "Non expédié",
    "YGJ": "Estimation",
    "GGBM": "Code de spécification",
    "SLHJ": "Total de quantité",
    "JEHJ": "Total de montant",
    "QPLKY": "Utilisable pour toutes les catégories",
    "KYCXHDDJSY": "Utilisable en combinaison avec les promotions",
    "BKDKYF": "Ne peut pas déduire les frais de livraison",
    "SYHBYTH": "Non remboursable après utilisation",
    "TiJi": "Volume",
    "ZhongLiang": "Poids",
    "ZongTiJi": "Volume total",
    "ZongZhongLiang": "Poids total",
    "QSRDHDCKDWLDHSJRSJH": "Veuillez entrer le numéro de commande/numéro de sortie de stock/numéro de suivi/destinataire/numéro de téléphone",
    "CKDH": "Numéro de sortie de stock",
    "WLDZT": "Statut du document de logistique",
    "WLDH": "Numéro de suivi",
    "SJR": "Destinataire",
};
export default fr_FR
